import { Observable } from 'rxjs';
import { APIResponseWrapper } from '../../models/common/api-response-wrapper';
import * as HrModels from '../hr.models';
import { Constructor, HrApiClient } from '../shared/hr-api-client';

export function withHrSelfServiceApi<TBase extends Constructor<HrApiClient>>(Base: TBase) {
  return class extends Base {
    selfProfile(): Observable<APIResponseWrapper<HrModels.HrSelfServiceProfile>> {
        return this.http.get<APIResponseWrapper<HrModels.HrSelfServiceProfile>>(`${this.baseUrl}/self-service/profile`);
      }
    
    selfDocuments(): Observable<APIResponseWrapper<HrModels.HrEmployeeDocument[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrEmployeeDocument[]>>(`${this.baseUrl}/self-service/documents`);
      }
    
    uploadSelfDocument(request: HrModels.HrEmployeeDocument): Observable<APIResponseWrapper<HrModels.HrEmployeeDocument>> {
        return this.http.post<APIResponseWrapper<HrModels.HrEmployeeDocument>>(`${this.baseUrl}/self-service/documents`, request);
      }
    
    selfLeave(): Observable<APIResponseWrapper<HrModels.HrLeaveRequest[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrLeaveRequest[]>>(`${this.baseUrl}/self-service/leave`);
      }
    
    selfTimesheets(): Observable<APIResponseWrapper<HrModels.HrTimesheet[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrTimesheet[]>>(`${this.baseUrl}/self-service/timesheets`);
      }
    
    selfPayslips(): Observable<APIResponseWrapper<HrModels.HrPayslip[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrPayslip[]>>(`${this.baseUrl}/self-service/payslips`);
      }
    
    selfLearning(): Observable<APIResponseWrapper<HrModels.HrLearningAssignment[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrLearningAssignment[]>>(`${this.baseUrl}/self-service/learning`);
      }
    
    notificationPreferences(): Observable<APIResponseWrapper<HrModels.HrNotificationPreference[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrNotificationPreference[]>>(`${this.baseUrl}/self-service/notification-preferences`);
      }
    
    saveNotificationPreference(request: HrModels.HrNotificationPreference): Observable<APIResponseWrapper<HrModels.HrNotificationPreference>> {
        return this.http.post<APIResponseWrapper<HrModels.HrNotificationPreference>>(`${this.baseUrl}/self-service/notification-preferences`, request);
      }
    
    managerTeamSummary(): Observable<APIResponseWrapper<HrModels.HrManagerTeamSummary>> {
        return this.http.get<APIResponseWrapper<HrModels.HrManagerTeamSummary>>(`${this.baseUrl}/self-service/manager/team-summary`);
      }
    
    managerApprovalQueue(): Observable<APIResponseWrapper<HrModels.HrManagerApprovalItem[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrManagerApprovalItem[]>>(`${this.baseUrl}/self-service/manager/approval-queue`);
      }
  };
}

